import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
	accesstoken:'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImIwMTQwYjM4LTg4NTEtNDMxMy1hYzY2LWY0Nzg2OWE2YTEyNiJ9.87k8hrGKwx5MWxWFyX_3vyvWakgt',
    // 设备id，以供全局使用
    deviceId: '0',
	ability: 1, //0音频1视频
    // 是否验证，开关
	login:false,
	isclose:false,
	statename:'准备',
	roomtel:'',
    // 定义一个callinfo，以供全局使用
    callinfo: { meid: '', peerid: '',server:'box.chinahjz.cn',doorname:'',phone:'',remoteurl:'',remotemqtturl:'' }
  },
});

export default store;
